
  (function(globalWindow) {
    var serviceIdMapper = {
      amex: 'americanexpress'}; function debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };

    function createShowIconHandler(providerType) {
      return function keyUpHandler(event) {
        var targetNumber = event.target.value;
        var rawCardType = $.payment.cardType(targetNumber);
        var cardType = serviceIdMapper[rawCardType] || rawCardType;
        var creditcardIcons = $('.js-' + providerType + '-credit-card-icon');
        var inputIcon = $('.js-' + providerType + '-input-icon');

        if (!cardType) {
          if (inputIcon.is(':visible')) inputIcon.hide();
          return;
        }

        var currentCreditCardIcon = $('.js-' + providerType + '-credit-card-type-' + cardType);

        inputIcon.attr('src', currentCreditCardIcon.attr('src'));
        inputIcon.attr('alt', currentCreditCardIcon.attr('alt'));
        inputIcon.show();
      };
    }

    function createCreditcardChecker(settings) {
      var providerType = settings.providerType;
      var $cardNumberEl = settings.fields.cardNumber;

      var showInputIcon = debounce(createShowIconHandler(providerType), 100);

      $cardNumberEl.keyup(showInputIcon);
    }

    globalWindow.checkout = globalWindow.checkout || {};
    globalWindow.checkout.utils = globalWindow.checkout.utils || {};
    globalWindow.checkout.utils.debounce = globalWindow.checkout.utils.debounce || debounce;
    globalWindow.checkout.createCreditcardChecker = globalWindow.checkout.createCreditcardChecker || createCreditcardChecker;
  })(window);

  (function(globalWindow) {
    function getErrorMessage(reason) {
      switch (reason) {
        case 'cvv':
          return "Credit card CVV number is invalid";
        case 'expirationyear':
          return "Credit card expiry year is invalid";
        case 'expirationmonth':
          return "Credit card expiry month is invalid";
        case 'expirationdate':
          return "Credit card expiration date is invalid";
        case 'cardnumber':
          return "Credit card number is invalid";
        case 'zipcode':
          return "Credit card Zipcode is invalid";
        case 'streetaddress':
          return "Credit card Street Address is invalid";
        default:
          return "We are experiencing technical difficulties. Please try again later.";
      }
    }

    function validateCreditCard(cardDetails) {
      var cardNumber = cardDetails.cardNumber;
      var cardExpMonth = cardDetails.cardExpMonth;
      var cardExpYear = cardDetails.cardExpYear;
      var cardCVC = cardDetails.cardCVC;

      var errors = [];

      function validate() {
        if (!$.payment.validateCardNumber(cardNumber)) {
          errors.push(getErrorMessage('cardnumber'));
        }

        if (!$.payment.validateCardExpiry(cardExpMonth, cardExpYear)) {
          errors.push(getErrorMessage('expirationdate'));
        }

        if (!$.payment.validateCardCVC(cardCVC)) {
          errors.push(getErrorMessage('cvv'));
        }
      }

      validate();

      return {
        isValid: !errors.length,
        errors: errors,
      };
    }

    globalWindow.checkout = globalWindow.checkout || {};
    globalWindow.checkout.getErrorMessage = globalWindow.checkout.getErrorMessage || getErrorMessage;
    globalWindow.checkout.validateCreditCard = globalWindow.checkout.validateCreditCard || validateCreditCard;
  })(window);
